// extracted by mini-css-extract-plugin
module.exports = {"video_section":"style_video_section__eRlab"};